import {
  applySpec,
  compose,
  defaultTo,
  dissocPath,
  filter,
  find,
  map,
  omit,
  pathEq,
  prop,
  propEq,
  when
} from 'ramda';
import { useEffect, useState } from 'react';
import { useProcess } from '@fasstech/oip-starter-utils/app';
import useSaveSouscriptionActivePolicyMutation from './useSaveSouscriptionActivePolicyMutation.js';

const useActivePolicyForm = ({ middleFeatures, form }) => {
  const [loading, setLoading] = useState(false);

  const { processHandlers, context } = useProcess();

  const saveActivePolicy = useSaveSouscriptionActivePolicyMutation();

  const contractOnGoing = form.watch('activePolicy.contractOnGoing');
  const { isValid } = form.formState;

  useEffect(() => {
    form.trigger();
  }, []);

  const { IN_CHARGE_RESP } = middleFeatures;
  const inChargeOptions = compose(
    map(
      applySpec({
        label: prop('NOM'),
        value: prop('CODE'),
        needsCancellation: propEq('AFFICHAGE_CHAMPS', 'true'),
        fieldsAreRequired: propEq('CHAMPS_OBLIGATOIRES', 'true')
      })
    ),
    filter(propEq('AUTORISE', 'true'))
  )(IN_CHARGE_RESP || []);

  const selectedInChargeData = compose(
    defaultTo({}),
    find(propEq('value', form.watch('customer.activePolicies.0.cancellationApplicant')))
  )(inChargeOptions);

  const fieldsAreRequired = selectedInChargeData.fieldsAreRequired;

  useEffect(() => {
    form.clearErrors([
      'customer.activePolicies.0.name',
      'customer.activePolicies.0.insuranceAddress.fields',
      'customer.activePolicies.0.insuranceAddress.postCode',
      'customer.activePolicies.0.insuranceAddress.city'
    ]);
  }, [fieldsAreRequired]);

  const onSubmit = (values) => {
    if (loading) return;
    setLoading(true);
    values = compose(
      omit(['activePolicy']),
      when(
        pathEq(['activePolicy', 'contractOnGoing'], false),
        dissocPath(['customer', 'activePolicies'])
      )
    )(values);

    saveActivePolicy.onFormSubmit(values, (ok, error) => {
      if (ok && !error) {
        processHandlers.onNext({
          context: {
            projectId: context?.projectId
          }
        });
      } else {
        setLoading(false);
      }
    });
  };

  const onPrevious = () => {
    processHandlers.onPrev({
      context: {
        projectId: context?.projectId
      }
    });
  };

  return {
    contractOnGoing,
    inChargeOptions,
    selectedInChargeData,
    onSubmit,
    onPrevious,
    fieldsAreRequired,
    isValid
  };
};

export default useActivePolicyForm;
